import { Http } from '../Utils';
import { AmenityDto } from './dto';

export const fetchAmenities = async () => {
  return Http.get<AmenityDto[]>('amenities');
};
